import { Editor } from 'grapesjs';
import { getAllComponents, reactComponentsRegistry as rc } from '../reactComponentsRegistry';

// Регистрирует компоненты, связанные с блоками
export function registerLayoutComponents(editor: Editor) {
  editor.DomComponents.addType('flex-row', {
    isComponent: el => el.tagName === 'DIV' && el.classList.contains('gjs-flex-row'),
    model: {
      defaults: {
        tagName: 'div',
        droppable: true,
        style: {
          display: 'flex',
          'flex-direction': 'row',
          gap: '12px',
          padding: '16px',
          'min-height': '50px',
          'align-items': 'flex-start',
          'align-content': 'flex-start',
        },
        attributes: { class: 'gjs-flex-row' },
      },
    },
  });

  editor.DomComponents.addType('flex-column', {
    isComponent: el => el.tagName === 'DIV' && el.classList.contains('gjs-flex-column'),
    model: {
      defaults: {
        tagName: 'div',
        droppable: true,
        style: {
          display: 'flex',
          'flex-direction': 'column',
          gap: '12px',
          padding: '16px',
          'min-height': '100px',
        },
        attributes: { class: 'gjs-flex-column' },
      },
    },
  });

  editor.DomComponents.addType('block-container', {
    isComponent: el => el.tagName === 'DIV' && el.classList.contains('gjs-block-container'),
    model: {
      defaults: {
        tagName: 'div',
        droppable: true,
        style: {
          display: 'block',
          padding: '16px',
          'min-height': '40px',
          width: '100%',
        },
        attributes: { class: 'gjs-block-container' },
      },
    },
  });

  editor.DomComponents.addType('cities-choice', {
    isComponent: el => el.tagName === 'DIV' && el.classList.contains('gjs-cities-choice'),
    model: {
      defaults: {
        tagName: 'div',
        droppable: true,
        style: {
          display: 'block',
          padding: '16px',
          'min-height': '40px',
          width: '100%',
        },
        attributes: { class: 'gjs-cities-choice' },
        traits: [{ type: 'text', name: 'data-city', label: 'Название города' }],
      },
    },
  });
}

// Добавляет блоки в BlockManager
export function registerLayoutBlocks(editor: Editor) {
  editor.BlockManager.add('flex-row', {
    label: 'Flex Row',
    category: 'Layout',
    content: {
      type: 'flex-row',
      block: '<div>Row</div>',
    },
  });

  editor.BlockManager.add('flex-column', {
    label: 'Flex Column',
    category: 'Layout',
    content: {
      type: 'flex-column',
      block: '<div>Column</div>',
    },
  });

  editor.BlockManager.add('block-container', {
    label: 'Block Container',
    category: 'Layout',
    content: `
      <div data-gjs-type="block-container">
        <div data-gjs-type="flex-row">
          <div data-gjs-type="uiHeading1">Flex Row</div>
        </div>
        <div data-gjs-type="flex-row">
          <div data-gjs-type="uiText1">Text</div>
        </div>
      </div>`,
  });

  editor.BlockManager.add('cities-choice', {
    label: 'Cities Choice',
    category: 'Cities',
    content: `
      <div data-gjs-type="cities-choice">
        <${rc.UIHeading1.id}>Москва</${rc.UIHeading1.id}>
      </div>`,
  });
}

// Функция для добавления кастомных блоков из реестра
export function addReactComponentBlocks(editor: Editor) {
  const components = getAllComponents();

  components.forEach(compDef => {
    editor.BlockManager.add(compDef.id, compDef.block);
  });
}

// Главная функция инициализации всех блоков
export function initializeBlocks(editor: Editor) {
  // Регистрируем компоненты перед блоками
  registerLayoutComponents(editor);

  // Добавляем блоки
  registerLayoutBlocks(editor);
  addReactComponentBlocks(editor);
}
